function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.824,40.823H3c-1.657,0-3-1.343-3-3V3c0-1.657,1.343-3,3-3h34.824c1.657,0,3,1.343,3,3v34.823 C40.824,39.48,39.481,40.823,37.824,40.823 M6,34.823h28.823V6H6V34.823z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91,40.823H56.177c-1.657,0-3-1.343-3-3V3c0-1.657,1.343-3,3-3H91c1.658,0,3,1.343,3,3v34.823 C94,39.48,92.658,40.823,91,40.823 M59.177,34.823h28.824V6H59.177V34.823z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.824,94H3c-1.657,0-3-1.343-3-3V56.175c0-1.656,1.343-3,3-3h34.824c1.657,0,3,1.344,3,3V91 C40.824,92.657,39.481,94,37.824,94 M6,88h28.823V59.177H6V88z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91,94H56.177c-1.657,0-3-1.343-3-3V56.175c0-1.656,1.343-3,3-3H91c1.658,0,3,1.344,3,3V91 C94,92.657,92.658,94,91,94 M59.177,88h28.824V59.177H59.177V88z"
});

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "-0.067 -0.974 95 95",
    enableBackground: "new -0.067 -0.974 95 95",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.9d762af3.svg";
export { ForwardRef as ReactComponent };